import { render, staticRenderFns } from "./Step05Review.vue?vue&type=template&id=2a852a0e"
import script from "./Step05Review.vue?vue&type=script&lang=js"
export * from "./Step05Review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports